import {Alert, Chip, Stack} from "@mui/material";
import {AccessDto, JobPeriodType} from "../../../api/psc";

// updated
export default function ProjectAccessCountAvailabilityBox(props: {
    access: AccessDto;
}) {
    const {availableCount, resetCount} = props.access.viewCounter;

    const getResetTypeTitle = () => {
        switch (props.access.viewCounter.resetType) {
            case JobPeriodType.NONE:
                return ''
            case JobPeriodType.DAILY:
                return 'روزانه'
            case JobPeriodType.MONTHLY:
                return 'ماهیانه'
            case JobPeriodType.WEEKLY:
                return 'هفتگی'

        }
    }

    if (availableCount > 0) {
        return (
            <Alert
                severity="success"
                action={
                    <Chip
                        size="small"
                        color="success"
                        label={availableCount + " عدد"}
                    />
                }
            >

                <Stack direction="row" spacing={0.5}>
                    <span>تعداد قابل برداشت</span>
                    <span>{getResetTypeTitle()}</span>
                </Stack>
            </Alert>
        );
    }

    if (availableCount === 0) {
        return (
            <Alert severity="warning">
                دسترسی انتخاب شده به حد مجاز {resetCount} بازدید
                رسیده است
            </Alert>
        );
    }

    return <></>;
}
